import React from 'react';

const VIEW_ICONS = {
  week: (
    <svg width="14" height="14" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
      <rect x="1" y="1" width="6" height="6" rx="1" />
      <rect x="9" y="1" width="6" height="6" rx="1" />
      <rect x="1" y="9" width="6" height="6" rx="1" />
      <rect x="9" y="9" width="6" height="6" rx="1" />
    </svg>
  ),
  list: (
    <svg width="14" height="14" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
      <rect x="2" y="3" width="12" height="2" rx="0.5" />
      <rect x="2" y="7" width="12" height="2" rx="0.5" />
      <rect x="2" y="11" width="12" height="2" rx="0.5" />
    </svg>
  ),
  calendar: (
    <svg width="14" height="14" viewBox="0 0 16 16" fill="none" aria-hidden="true">
      <rect x="2" y="3" width="12" height="11" rx="1.5" stroke="currentColor" strokeWidth="1.4" />
      <path d="M2 6h12M5 1.5v3M11 1.5v3" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
    </svg>
  ),
};

const CALENDAR_PERIOD_ICON = (
  <svg
    className="calendar-period-icon"
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
  >
    <rect x="4" y="5" width="16" height="15" rx="2" stroke="currentColor" strokeWidth="1.6" />
    <path d="M4 9h16M8 3v4M16 3v4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
  </svg>
);

const VIEW_OPTIONS = [
  { id: 'week', label: 'Hét nézet' },
  { id: 'list', label: 'Lista nézet' },
  { id: 'calendar', label: 'Naptár nézet' },
];

function CalendarViewControls({
  viewMode,
  onViewModeChange,
  periodLabel,
  onPrevPeriod,
  onNextPeriod,
  showPeriodNav = true,
}) {
  return (
    <div className="calendar-controls">
      <div className="calendar-controls__bar">
        {showPeriodNav ? (
          <div className="calendar-controls__nav">
            <button type="button" className="calendar-nav-btn" onClick={onPrevPeriod}>
              <span className="calendar-nav-btn__chevron" aria-hidden="true">
                &lt;
              </span>
              Előző hét
            </button>
            <p className="calendar-period-label">
              {CALENDAR_PERIOD_ICON}
              <span>{periodLabel}</span>
            </p>
            <button type="button" className="calendar-nav-btn" onClick={onNextPeriod}>
              Következő hét
              <span className="calendar-nav-btn__chevron" aria-hidden="true">
                &gt;
              </span>
            </button>
          </div>
        ) : (
          <div className="calendar-controls__nav calendar-controls__nav--spacer" aria-hidden="true" />
        )}

        <div className="calendar-view-toggle" role="tablist" aria-label="Naptár nézet">
          {VIEW_OPTIONS.map((opt) => (
            <button
              key={opt.id}
              type="button"
              role="tab"
              aria-selected={viewMode === opt.id}
              className={`calendar-view-btn${
                viewMode === opt.id ? ' calendar-view-btn--active' : ''
              }`}
              onClick={() => onViewModeChange(opt.id)}
            >
              <span className="calendar-view-btn__icon">{VIEW_ICONS[opt.id]}</span>
              {opt.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

export default CalendarViewControls;
